import React, { useCallback, useEffect, useState } from 'react';
import { HashRouter as Router } from 'react-router-dom';

import { hotjar } from 'react-hotjar';
if (process.env.NODE_ENV === 'production') hotjar.initialize(2306743, 6);

import Providers from './Providers';

import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/App.css';
import 'react-datepicker/dist/react-datepicker.css';

export default function App() {
  const [branding, setBranding] = useState({});

  const fetchBranding = useCallback(async () => {
    await setTheme();
    const brandingResponse = await window
      .fetch(getBlobPath())
      .then((res) => res.json());

    const style = window.getComputedStyle(document.body);
    const primary_alert = style
      .getPropertyValue('--brand-primary-alert')
      .trim();

    const brandBoolean = getBrandingBoolean();
    setBranding({ ...brandingResponse, ...brandBoolean, primary_alert });
    const {
      apple_touch_icon_url,
      apple_touch_icon_57_url,
      apple_touch_icon_72_url,
      apple_touch_icon_76_url,
      apple_touch_icon_114_url,
      apple_touch_icon_120_url,
      apple_touch_icon_144_url,
      apple_touch_icon_152_url,
      apple_touch_icon_180_url,
      favicon_url,
      title,
    } = brandingResponse || {};

    if (apple_touch_icon_url) {
      const touchIcon = getEl('appleTouchIcon');
      touchIcon.href = apple_touch_icon_url;
    }
    if (apple_touch_icon_57_url) {
      const touchIcon57 = getEl('appleTouchIcon57');
      touchIcon57.href = apple_touch_icon_57_url;
    }
    if (apple_touch_icon_72_url) {
      const touchIcon72 = getEl('appleTouchIcon72');
      touchIcon72.href = apple_touch_icon_72_url;
    }
    if (apple_touch_icon_76_url) {
      const touchIcon76 = getEl('appleTouchIcon76');
      touchIcon76.href = apple_touch_icon_76_url;
    }
    if (apple_touch_icon_114_url) {
      const touchIcon114 = getEl('appleTouchIcon114');
      touchIcon114.href = apple_touch_icon_114_url;
    }
    if (apple_touch_icon_114_url) {
      const touchIcon114 = getEl('appleTouchIcon114');
      touchIcon114.href = apple_touch_icon_114_url;
    }
    if (apple_touch_icon_120_url) {
      const touchIcon120 = getEl('appleTouchIcon120');
      touchIcon120.href = apple_touch_icon_120_url;
    }
    if (apple_touch_icon_144_url) {
      const touchIcon144 = getEl('appleTouchIcon144');
      touchIcon144.href = apple_touch_icon_144_url;
    }
    if (apple_touch_icon_152_url) {
      const touchIcon152 = getEl('appleTouchIcon152');
      touchIcon152.href = apple_touch_icon_152_url;
    }
    if (apple_touch_icon_180_url) {
      const touchIcon180 = getEl('appleTouchIcon180');
      touchIcon180.href = apple_touch_icon_180_url;
    }
    if (favicon_url) {
      const favicon = getEl('favicon');
      favicon.href = favicon_url;
    }
    if (title) document.title = title;
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [fetchBranding]);
  return <Router>{branding ? <Providers branding={branding} /> : null}</Router>;
}

function getBlobPath() {
  let relativePath;
  switch (true) {
    case window.location.host.toLowerCase().includes('branded') &&
      window.location.host.toLowerCase().includes('experience'):
      relativePath = '/branded-experience/branded-experience.json';
      break;
    case window.location.host.toLowerCase().includes('customer') &&
      window.location.host.toLowerCase().includes('demo'):
      relativePath = '/customer-demo/customer-demo.json';
      break;
    case window.location.host.toLowerCase().includes('enovation'):
      relativePath = '/enovation/enovation.json';
      break;
    case window.location.host.toLowerCase().includes?.('mysupra'):
      relativePath = '/supraboats/supraboats.json';
      break;
    case window.location.host.toLowerCase().includes('versatile'):
      relativePath = '/versatile/versatile.json';
      break;
    case window.location.host.toLowerCase().includes('barko'):
      relativePath = '/barko/barko.json';
      break;
    default:
      relativePath = '/elevat/elevat.json';
      break;
  }

  return `${process.env.BRANDING_BLOB_BASE_URL}${relativePath}`;
}

function getBrandingBoolean() {
  switch (true) {
    case window.location.host.toLowerCase().includes('branded') &&
      window.location.host.toLowerCase().includes('experience'):
      return { isBrandedExperienceUi: true };
    case window.location.host.toLowerCase().includes('customer') &&
      window.location.host.toLowerCase().includes('demo'):
      return { isCustomerDemoUi: true };
    case window.location.host.toLowerCase().includes('enovation'):
      return { isEnovationUi: true };
    case window.location.host.toLowerCase().includes?.('mysupra'):
      return { isSupraUi: true };
    case window.location.host.toLowerCase().includes('versatile'):
      return { isVersatileUi: true };
    case window.location.host.toLowerCase().includes('barko'):
      return { isBarkoUi: true };
    default:
      return { isElevatUi: true };
  }
}

function getEl(id) {
  return document.getElementById(id);
}

async function setTheme() {
  switch (true) {
    case window.location.host.toLowerCase().includes('branded') &&
      window.location.host.toLowerCase().includes('experience'):
      return import('./Styles/branded-experience.scss');
    case window.location.host.toLowerCase().includes('customer') &&
      window.location.host.toLowerCase().includes('demo'):
      return import('./Styles/customer-demo.scss');
    case window.location.host.toLowerCase().includes('enovation'):
      return import('./Styles/enovation.scss');
    case window.location.host.toLowerCase().includes?.('mysupra'):
      return import('./Styles/supraboats.scss');
    case window.location.host.toLowerCase().includes('versatile'):
      return import('./Styles/versatile.scss');
    case window.location.host.toLowerCase().includes('barko'):
      return import('./Styles/barko.scss');
    default:
      return import('./Styles/elevat.scss');
  }
}
